<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :itemText="itemText"
            :disabled="disabled"
            @change="$emit('change', $event)"
            :show-add="showAdd"
            :dense="dense"
            :multiple="multiple"
            :outlined="outlined"
        />
        <sys-register-term @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectTerm',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        itemText: {
            type: String,
            default: 'name'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: null
        }
    },
    watch: {
        selected(val){
            this.$emit('update:model', val);
        },
        model(val){
            this.selected = val;
        },
        data(val) {
            if (val && typeof val === 'object' && val.id && !this.items.find(i => i.id === val.id)) {
                this.items = [val, ...this.items];
                this.selected = this.model;
            }
        }
    },
    methods: {
        ...mapActions('term', ['ActionIndexTerms']),        
        
        async getItems() {
            this.loading = true;
            await this.ActionIndexTerms()
                .then((res) => {
                    this.items = res.data || [];
                    if (this.data && typeof this.data === 'object' && this.data.id && !this.items.find(i => i.id === this.data.id)) {
                        this.items = [this.data, ...this.items];
                    }
                    this.selected = this.model;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>